<template>
  <div class="header">
    <div
      class="header-bar"
      :class="{ bgWhite: isShowBar, 'header-absolute': env.isWx, 'vivo-app-no-os-4': isVivoAppNoOS4 }"
    >
      <!-- 占位，用于占用App的顶部信号栏高度 -->
      <div :style="{ height: nativeHeight }"></div>
      <!-- titlebar内容 -->
      <div class="content">
        <div @click="goBack" class="icon back" tabindex="0" role="button" aria-label="返回">
          <v-icon class="icon-back" name="arrow-left-v3"></v-icon>
        </div>
        <div v-if="isShowBar" class="title">
          <span class="text">{{ title }}</span>
        </div>
        <div class="right">
          <!-- todo:这里需要注意左侧只能显示一个icon，如果显示两个icon，需要处理os3标题居中的场景 -->
          <div class="icon share" v-if="showShare" @click="doPageShare" tabindex="0" role="button" aria-label="分享">
            <v-icon class="i-share" name="icon-share"></v-icon>
          </div>
          <div
            class="icon menu"
            v-if="showMenu"
            @click="isShowMenu = !isShowMenu"
            tabindex="0"
            role="button"
            aria-label="菜单"
          >
            <v-icon class="i-menu" name="icon-menu-v3"></v-icon>
          </div>
        </div>
        <v-header-menu v-if="showMenu" :isShowMenu="isShowMenu" @close="closeMenu"></v-header-menu>
      </div>
    </div>
  </div>
</template>

<script>
// 环境
import env from '@/utils/clientEnv'
import { app, common } from '@/utils'
import create from '../create'
export default create({
  name: 'HeaderPro',
  components: {},
  props: {
    pageShareParams: {
      type: Object
    },
    title: {
      type: String,
      default: ''
    },
    showShare: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: false
    },
    // 监听滚动元素（为id、class）
    scrollSelector: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      env,
      // 官网App顶部高度
      nativeHeight: '',
      isShowBar: false,
      isShowMenu: false,
      scrollDom: null
    }
  },
  computed: {
    // 官网app且不是OS4系统
    isVivoAppNoOS4() {
      return env.isVivoApp && !env.isOS4 && !env.isIOSVivoApp
    }
  },
  created() {
    this.getNativeHeight()
    // 全屏的话重新获取statusBarHeight
    window.onFullScreen = () => {
      this.getNativeHeight()
    }
  },
  mounted() {
    // 绑定滚动事件，用于切换titlebar
    if (!env.isWx) {
      if (this.scrollSelector) {
        this.scrollDom = document.querySelector(this.scrollSelector)
      }
      this.bindScrollEvent()
    }
  },
  methods: {
    closeMenu() {
      this.isShowMenu = false
    },
    /**
     * 绑定滚动事件，用于切换titlebar
     */
    bindScrollEvent() {
      let self = this
      // 不使用节流，是为了快速切换titlebar，提升体验
      if (this.scrollDom) {
        this.scrollDom.addEventListener('scroll', () => {
          const scrollTop = this.scrollDom.scrollTop
          self.isShowBar = scrollTop > 40
        })
      } else {
        window.addEventListener('scroll', function () {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          self.isShowBar = scrollTop > 40
        })
      }
    },
    getNativeHeight() {
      let self = this
      app.getTitleBarHeight({
        type: 'statusBarHeight',
        success: res => {
          // + 10  为了多空一些距离，避免太靠近
          if (env.isIOSVivoApp) {
            self.nativeHeight = `${res}px`
          } else {
            self.nativeHeight =
              env.isPadVivoApp || env.isFoldableApp
                ? ((((res + 24) * 400) / (100 * 720)) * 150) / 100 + 'rem'
                : ((((res + 24) * window.screen.width) / (100 * 720)) * 150) / 100 + 'rem'
          }
        }
      })
    },

    /**
     * 点击分享
     */
    doPageShare() {
      this.$track({
        event_id: '244|009|01|077',
        cfrom: '244|009|01|077'
      })
      if (env.isVivoApp) {
        // app-H5
        app.setShareConfig(this.pageShareParams)
        setTimeout(() => {
          app.doShare()
        }, 20)
      } else if (env.isWx) {
        // 微信H5 - 展示图片
        this.$emit('showTip')
      } else {
        // 其他H5
        app.copyContent(window.location.href, () => {
          this.$toast('已复制')
        })
      }
    },

    /**
     * 返回上一页
     */
    goBack() {
      if (env.isVivoApp) {
        app.appGoBack()
      } else {
        try {
          if (window.history.length > 1 || (document.referrer && document.referrer != location.href)) {
            history.go(-1)
          } else {
            location.href = `${this.linkBase}/product/phone`
          }
        } catch (e) {}
      }
    }
  },
  watch: {
    isShowBar: {
      handler(val) {
        if (val) {
          app.setStatusBarColor('black')
        } else {
          app.setStatusBarColor('white')
        }
      },
      immediate: true
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
